<div class="login-content-container flex flex-column justify-content-between overflow-y-auto">
  <ng-content></ng-content>
</div>
